import React from "react";
import Navbar from "@/components/Navbar";
import TopDestinationsBar from "@/components/TopDestinationsBar";
import HeroSection from "@/components/HeroSection";
import DestinationsCarousel from "@/components/DestinationsCarousel";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <main className="relative">
      <Navbar />
      <TopDestinationsBar />
      <HeroSection />
      <DestinationsCarousel />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
